export const environment = {
  production: false,
  apiUrl: 'https://admin-dev.chircalnetwifi.com.ve/api',
};
